import { call } from "redux-saga/effects";
import { ClaroSDKService } from "../../services/sdk/ClaroSDKService";

export function* transactionWorkerSaga({ payload }) {
  try {
    const urlParam = new URLSearchParams(window.location.search);
    const bundleId = urlParam.get("bundleId");
    const isTelcel =
      process.env.REACT_APP_TELCEL_BUNDLE_VERSIONS.includes(bundleId);
    if (isTelcel && payload) {
      yield call(ClaroSDKService.getR1);
    }
  } catch (error) {
    console.log("ERROR!!",error)
  }
}
